module.exports = __webpack_public_path__ + "static/hero-budget-planner-491cb113c0dcb774050e6bedc0b47082.webp";